<template>
  <div class="vk-alert-component" v-show="showAlert">
    <div class="vk-alert-module">
      <img class="header-img" src="@/assets/images/order/alert-img.png" />
      <div class="vk-alert-title" :style="{'text-align': align}">
        <span>{{title}}</span>
        <img src="@/assets/images/order/close.png" @click="doClose" />
      </div>
      <div class="vk-alert-content" :style="{'text-align': align}">
        <div>{{content}}</div>
        <div class="vk-alert-content-info" v-if="info">{{info}}</div>
      </div>
      <div class="vk-alert-footer" :style="{'text-align': align}">
        <span v-if="type === 'confirm'" @click="cancel" class="cancel-btn">{{cancelBtnText}}</span>
        <span @click="sure" class="ok-btn">{{sureBtnText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    sureBtnText: {
      type: String,
      default: "知道了"
    },
    cancelBtnText: {
      type: String,
      default: "取消"
    },
    align: {
      type: String,
      default: "left"
    }
  },
  data() {
    return {
      type: "alert",
      showAlert: false,
      resolve: "",
      reject: "",
      promise: "",
      callback: ""
    };
  },
  methods: {
    doClose() {
      this.showAlert = false;
      this.remove();
    },
    cancel() {
      this.close("cancel");
    },
    sure() {
      this.close("sure");
    },
    close(action) {
      this.showAlert = false;
      if (this.type === "confirm") {
        action === "sure" ? this.resolve(action) : this.reject(action);
      }
      this.type === "alert" &&
        typeof this.callback === "function" &&
        this.callback(action);
      this.remove();
    },
    showAlertComponent(callback) {
      document.querySelector("body").style.overflow = "hidden";
      this.showAlert = true;
      this.callback = callback;
    },
    showConfirmComponent() {
      document.querySelector("body").style.overflow = "hidden";
      this.showAlert = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      return this.promise;
    },
    // 手动移除组件以及元素
    remove() {
      setTimeout(() => {
        document.querySelector("body").style.overflow = "auto";
        this.$destroy();
        document.body.removeChild(this.$el);
      }, 300);
    }
  }
};
</script>

<style lang="less" scoped>
.vk-alert-component {
  position: fixed;
  z-index: 3000; // 注意z-index高于vk-dialog
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  .vk-alert-module {
    position: absolute;
    width: 400px;
    height: auto;
    background-color: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 5px solid rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    .header-img {
      position: absolute;
      width: 140px;
      height: 91px;
      left: 50%;
      margin-left: -70px;
      top: -80px;
    }
    .vk-alert-title {
      position: relative;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      font-size: 22px;
      color: #000;
      img {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        height: 13px;
        width: 13px;
        cursor: pointer;
      }
    }
    .vk-alert-content {
      padding: 15px 40px;
      .vk-alert-content-info {
        margin-top: 20px;
        color: #808080;
        font-size: 12px;
        line-height: 20px;
      }
    }
    .vk-alert-footer {
      padding: 15px 40px 30px;
      span {
        display: inline-block;
        cursor: pointer;
        height: 40px;
        line-height: 38px;
        margin-right: 10px;
        border-radius: 3px;
        font-size: 16px;
        padding: 0 25px;
        &.ok-btn {
          border: 1px solid #f60;
          background-color: #f60;
          color: #fff;
          transition: opacity 0.2s;
          &:hover {
            opacity: 0.82;
          }
        }
        &.cancel-btn {
          border: 1px solid #b9b9b9;
          transition: all 0.2s;
          &:hover {
            border-color: #f60;
            color: #f60;
          }
        }
      }
    }
  }
}
</style>
